/**
 * Plugin that makes part of the page look like 3D scrolling
 */
export default class ImageSizes {
    /**
     * Constructor
     */
    constructor()
    {
        this.init();
    }

    /**
     * Init function
     */
    init()
    {
        this.updateSizes();
        $(window).resize(this.updateSizes);
    }

    updateSizes() {
        $('[data-dynamic-sizes]').each(function() {
            var width = $(this).width();
            $(this).attr("sizes",  parseInt(width) + "px");
        });
    }
}
